export const colors = {
  dark: {
    bg: '#06060e',
    bg2: '#08081a',
    surface: 'rgba(255,255,255,0.03)',
    surface2: 'rgba(255,255,255,0.05)',
    surface3: 'rgba(255,255,255,0.07)',
    text1: '#e0e0f0',
    text2: '#7878a0',
    text3: '#4a4a68',
    primary: '#7c5cfc',
    primary2: '#9b7dff',
    cyan: '#00d4ff',
    pink: '#ff6bca',
    green: '#34d399',
    red: '#f87171',
    yellow: '#fbbf24',
    blue: '#60a5fa',
    border: 'rgba(255,255,255,0.05)',
  },
  light: {
    bg: '#f8f8fc',
    bg2: '#f0f0f8',
    surface: 'rgba(255,255,255,0.85)',
    surface2: 'rgba(255,255,255,0.92)',
    surface3: 'rgba(255,255,255,1)',
    text1: '#1a1a2e',
    text2: '#6a6a88',
    text3: '#9a9ab0',
    primary: '#6c5ce7',
    primary2: '#8b7cf0',
    cyan: '#00d4ff',
    pink: '#ff6bca',
    green: '#34d399',
    red: '#f87171',
    yellow: '#fbbf24',
    blue: '#60a5fa',
    border: 'rgba(0,0,0,0.06)',
  },
} as const;

export const gradients = {
  primary: 'linear-gradient(135deg, #7c5cfc, #00d4ff, #ff6bca)',
  aurora: 'linear-gradient(135deg, #7c5cfc, #00d4ff)',
  userMessage: 'linear-gradient(135deg, #7c5cfc, #00d4ff)',
} as const;

export const glows = {
  primary: '0 0 20px rgba(124,92,252,0.25)',
  cyan: '0 0 20px rgba(0,212,255,0.25)',
  pink: '0 0 20px rgba(255,107,202,0.25)',
  neonBreath: '0 0 30px rgba(124,92,252,0.35), 0 0 60px rgba(0,212,255,0.1)',
} as const;

export const typography = {
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  heading1: { fontSize: '30px', fontWeight: 700, lineHeight: 1.2 },
  heading2: { fontSize: '22px', fontWeight: 700, lineHeight: 1.3 },
  heading3: { fontSize: '18px', fontWeight: 600, lineHeight: 1.4 },
  heading4: { fontSize: '15px', fontWeight: 600, lineHeight: 1.4 },
  body: { fontSize: '14px', fontWeight: 400, lineHeight: 1.7 },
  bodySmall: { fontSize: '13px', fontWeight: 400, lineHeight: 1.6 },
  caption: { fontSize: '12px', fontWeight: 400, lineHeight: 1.5 },
  label: { fontSize: '11px', fontWeight: 500, lineHeight: 1.4 },
} as const;

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '32px',
  '4xl': '48px',
} as const;

export const radius = {
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  '2xl': '24px',
  full: '9999px',
} as const;

export const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1025px',
} as const;
